import { ITableSetting } from "../../../../Table/BasicTable";
import { FeatureSetProduct } from "../../../../../models/Offerings/featureSet";
import { IconWrapper } from "../../../ui-components/pageLayout/TableSettingsComponents";
import { MdDelete } from "react-icons/md";
import React from "react";

export const ProductsTableSettings = (
  onDelete?: (index: number) => void
): ITableSetting<FeatureSetProduct>[] => [
  {
    id: "product-id",
    align: "left",
    name: "PRODUCT",
    path: "PRODUCT",
    content: (data: FeatureSetProduct) => <div>{data.getDisplayName()}</div>,
  },
  {
    id: "features-id",
    align: "left",
    name: "FEATURES",
    path: "FEATURES",
    content: (data: FeatureSetProduct) => <div>{data.features.toString()}</div>,
  },
  {
    id: "delete-id",
    align: "right",
    name: "",
    path: "delete",
    content: (data: FeatureSetProduct, index) => (
      <IconWrapper
        onClick={() => (onDelete ? onDelete(index) : null)}
        style={{ float: "right" }}
      >
        <MdDelete />
      </IconWrapper>
    ),
  },
];
